<script lang="ts" setup>
import zhCn from "element-plus/es/locale/lang/zh-cn"
import { debounce } from "lodash-es"
import { useTheme } from "@/hooks/useTheme"

const { initTheme } = useTheme()

/** 初始化主题 */
initTheme()
/** 将 Element Plus 的语言设置为中文 */
const locale = zhCn

const _ = (window as any).ResizeObserver;
(window as any).ResizeObserver = class ResizeObserver extends _ {
  constructor(callback: (...args: any[]) => void) {
    callback = debounce(callback, 0)
    super(callback)
  }
}
</script>

<template>
  <ElConfigProvider :locale="locale">
    <router-view />
  </ElConfigProvider>
</template>
